/*
*   NOTE: This sample uses ES6 features
*/
import config from '../../../src/config'
import getRegionalConfiguration from './util';
import EbConstants from './constants';
const platformClient = window.require('platformClient');

const appConfig = config;
// JQuery Alias
const $ = window.$;

// Relative path to wizard page from config's redirectUri
//const WIZARD_PAGE = "/index.html";

const pageSize = 500;
/**
 * WizardApp class that handles everything in the App.
 */
class WizardApp {
    constructor(redirectUri) {
        this.pcEnvironment = null;
        this.org = null;

        // PureCloud Javascript SDK clients
        this.platformClient = platformClient;
        this.purecloudClient = this.platformClient.ApiClient.instance;
        this.purecloudClient.setPersistSettings(true, appConfig.integrationType);
        this.redirectUri = appConfig.appUrl + "index.html";

        // PureCloud API instances
        this.usersApi = new this.platformClient.UsersApi();
        this.integrationsApi = new this.platformClient.IntegrationsApi();
        this.authApi = new this.platformClient.AuthorizationApi();
        this.oAuthApi = new this.platformClient.OAuthApi();
        this.objectsApi = new this.platformClient.ObjectsApi();
        this.organizationApi = new this.platformClient.OrganizationApi();

        // Language default is english
        // Language context is object containing the translations
        this.language = appConfig.defaultLangTag;

        this.integrationType = appConfig.integrationType;

        this.appName = appConfig.appName;
        this.appUrl = appConfig.appUrl;

        this.installationData = appConfig.provisioningInfo;
        //this.installationData = appConfig.provisioningInfo;
        this.orgDivisions;
        this.orgDivisionNames;
        this.getPermissions().then((permissionResponse) => {
            console.log(`getPermissions response is ${JSON.stringify(permissionResponse)}`);
            this.installationData = permissionResponse.Items.permissions;
            let OAuthname = this.installationData.oauth.name;
            OAuthname = OAuthname.replace("${appName}",this.appName);
            this.installationData.oauth.name = OAuthname;
            let roleName = this.installationData.roles[0].name.replace("${appName}",appConfig.appName);
            this.installationData.roles[0].name = roleName;
        
            console.log(`ProvisioningInfo is ${JSON.stringify(this.installationData)}`);
        }).catch((e) => {
            console.log('Error in install view: ' + e);
        });
    }

    //// =======================================================
    ////      ENTRY POINT
    //// =======================================================
    start() {
        return new Promise((resolve, reject) => {
            this._setupClientApp()
                .then(() => {
                    return this._pureCloudAuthenticate()
                })
                .then((data) => {
                    // console.log('start, data = ', JSON.stringify(data, null, 3));
                    if (data && data.accessToken) {
                        sessionStorage.setItem('purecloud-csp-token', data.accessToken);
                    }
                    console.log('Setup success');
                    this.getDivisions().then((divisionResponse)=>{
                        console.log(`getDivisions response is ${JSON.stringify(divisionResponse)}`);
                        
                        this.orgDivisions = divisionResponse.entities.map(function (obj){
                            return obj.id?obj.id :null;
                        });
                        this.orgDivisionNames = divisionResponse.entities.map(function (obj){
                            return obj.name?obj.name : 'NA';
                        });
                        console.log(`getDivisions is ${JSON.stringify(this.orgDivisions)}`);
                        console.log(`orgDivisionNames is ${JSON.stringify(this.orgDivisionNames)}`);
                    }).catch((e) => {
                        console.log('Error in install view: ' + e);
                    });
                    return this.organizationApi.getOrganizationsMe()
                }).then((orgData) => {
                    this.org = orgData
                    return resolve();
                })
                .catch((err) => {
                    console.log(err);
                    reject(err)
                });
        });
    }

    /**
     * First thing that needs to be called to setup up the PureCloud Client App
     */
    _setupClientApp() {
        // Snippet from URLInterpolation example: 
        // https://github.com/MyPureCloud/client-app-sdk
        const queryString = window.location.search.substring(1);
        const pairs = queryString.split('&');

        let pcEnv = null;
        let langTag = null;

        for (let i = 0; i < pairs.length; i++) {
            const currParam = pairs[i].split('=');

            if (currParam[0] === 'langTag') {
                langTag = currParam[1];
            } else if (currParam[0] === 'environment') {
                pcEnv = currParam[1];
            }
        }

        // Stores the query parameters into sessionStorage
        // If query parameters are not provided, try to get values from sessionStorage
        // Default values if it does not exist.
        if (pcEnv) {
            sessionStorage.setItem('purecloud-csp-env', pcEnv);
        } else if (sessionStorage.getItem('purecloud-csp-env')) {
            pcEnv = sessionStorage.getItem('purecloud-csp-env');
        } else {
            // Use default PureCloud region
            pcEnv = appConfig.defaultPcEnv;
            sessionStorage.setItem('purecloud-csp-env', pcEnv);
        }

        this.pcEnvironment = pcEnv;
        console.log("Environment:" + this.pcEnvironment);

        if (langTag) {
            sessionStorage.setItem('purecloud-csp-langTag', langTag);
        } else if (sessionStorage.getItem('purecloud-csp-langTag')) {
            langTag = sessionStorage.getItem('purecloud-csp-langTag');
        } else {
            // Use default Language
            langTag = appConfig.defaultLangTag;
        }
        this.language = langTag;

        console.log("Language:" + this.language);

        // Get the language context file and assign it to the app
        // For this example, the text is translated on-the-fly.
        return new Promise((resolve, reject) => {
            const fileUri = '../languages/' + this.language + '.json';
            $.getJSON(fileUri)
                .done(data => {
                    this.displayPageText(data);
                    resolve();
                })
                .fail(xhr => {
                    console.error(`Language file not found - "${this.language}.json. Loading default language"`)
                    this.language = 'en-us'
                    sessionStorage.setItem('purecloud-csp-langTag', 'en-us');
                    this.loadDefaultLanguage()
                    resolve();
                });
        });
    }

    loadDefaultLanguage() {
        $.getJSON('../languages/en-us.json')
            .done(data => {
                this.displayPageText(data);
            })
            .fail(xhr => {
                //reject(new Error(`Language file not found - "${this.language}.json"`));
                console.error(`Language file not found - "${this.language}.json"`)
            });
    }

    /**
    * Renders the proper text language into the web pages
    * @param {Object} text  Contains the keys and values from the language file
    */
    displayPageText(text) {
        $(document).ready(() => {
            for (let key in text) {
                if (!text.hasOwnProperty(key)) continue;
                $("." + key).text(text[key]);
            }
        });
    }

    /**
     * Authenticate to PureCloud (Implicit Grant)
     * @return {Promise}
     */
    _pureCloudAuthenticate() {
        console.log('_pureCloudAuthenticate clientId =', appConfig.clientId);
        console.log('_pureCloudAuthenticate redirectUri =', this.redirectUri);
        console.log('_pureCloudAuthenticate pcEnvironment =', this.pcEnvironment);

        this.purecloudClient.setEnvironment(this.pcEnvironment);
        return this.purecloudClient.loginImplicitGrant(
            appConfig.clientId,
            this.redirectUri,
            { state: ('pcEnvironment=' + this.pcEnvironment) });
    }

    /**
    * Checks if the product is available in the current Purecloud org by
    * validating the integration type being enabled for the org
    * @return {Promise.<Boolean>}
    */
    validateProductAvailability() {
        // premium-app-usertemplates         
        return this.getEntities(this.integrationsApi, 'getIntegrationsTypes')
            .then((entities) => {
                // console.log('Integration types: ' + JSON.stringify(entities, null, 3));

                if (entities.filter((integType) => integType.id === this.integrationType)[0]) {
                    console.log("PRODUCT AVAILABLE");
                    return (true);
                } else {
                    console.log("PRODUCT NOT AVAILABLE");
                    return (false);
                }
            });
    }

    /**
    * Checks if any configured objects are still existing. 
    * This is based on the appName
    * @returns {Promise.<Boolean>} If any installed objects are still existing in the org. 
    */
    isExisting() {
        const promiseArr = [];

        promiseArr.push(this.getExistingRoles());
        promiseArr.push(this.getExistingAuthClients());

        return Promise.all(promiseArr)
            .then((results) => {
                console.log('isExisting, results = ' + JSON.stringify(results, null, 3));
                return results[0].length || results[1].length;
            });
    }

    /**
    * Get existing roles in purecloud based on appName
    * @returns {Promise.<Array>} PureCloud Roles
    */
    getExistingRoles() {
        const authOpts = {
            'name': appConfig.appName.replace(/\(/g, '\\(').replace(/\)/g, '\\)') + '*', // Wildcard to work like STARTS_WITH, need to escape ) and (
            'userCount': false
        };

        // console.log('Get existing roles: ' + JSON.stringify(authOpts, null, 3));
        return this.getEntities(this.authApi, 'getAuthorizationRoles', authOpts);
    }


    /**
     * Get existing authetication clients based on the prefix
     * @returns {Promise.<Array>} Array of PureCloud OAuth Clients
     */
    getExistingAuthClients() {
        return this.getEntities(this.oAuthApi, 'getOauthClients')
            .then((entities) => {
                //console.log('CHECK :::::::::::getExistingAuthClients, entities = ' + JSON.stringify(entities, null, 3));
                return entities.filter(entity => entity.name && entity.name.startsWith(this.appName) && entity.state == 'active');
            });
    }

    /**
     * Get details of the current user
     * @return {Promise.<Object>} PureCloud User data
     */
    getUserDetails() {
        const opts = { 'expand': ['authorization'] };
        return this.usersApi.getUsersMe(opts);
    }

    /**
    * Get all the products of A3S
    * @return {Promise.<Object>} A3S products
    */
    getProducts() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                headers: {
                    'token': sessionStorage.getItem('purecloud-csp-token'),
                    'env': this.pcEnvironment,
                    'tokensource': 'purecloud'
                },
                url: appConfig.endpoints.backend + '/products',
                contentType: 'application/json',
                success: function (result) {
                    console.log('get products');
                    resolve(result)
                },
                error: function (xhr, status, error) {
                    console.log('getProducts, xhr = ' + JSON.stringify(xhr, null, 3));
                    console.log('getProducts, status = ' + JSON.stringify(status, null, 3));
                    console.log('getProducts, error = ' + JSON.stringify(error, null, 3));

                    reject("Error in getting A3S products.");
                }
            });
        });
    }

    /**
    * Get all the Oauth permissions of A3S
    * @return {Promise.<Object>} A3S products
    */
    getPermissions() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                headers: {
                    'token': sessionStorage.getItem('purecloud-csp-token'),
                    'env': this.pcEnvironment,
                    'tokensource': 'purecloud'
                },
                url: appConfig.endpoints.backend + '/permission',
                contentType: 'application/json',
                success: function (result) {
                    console.log('get permission');
                    resolve(result)
                },
                error: function (xhr, status, error) {
                    console.log('getPermission, xhr = ' + JSON.stringify(xhr, null, 3));
                    console.log('getPermission, status = ' + JSON.stringify(status, null, 3));
                    console.log('getPermission, error = ' + JSON.stringify(error, null, 3));

                    reject("Error in getting A3S permision.");
                }
            });
        });
    }

    //// =======================================================
    ////      PROVISIONING
    //// =======================================================

    /**
     * Final Step of the installation wizard. 
     * Create the PureCloud objects defined in provisioning configuration
     * The order is important for some of the PureCloud entities.
     */
    installConfigurations(product) {
        console.log('Installing configurations');

        $.LoadingOverlay("show", {
            image: "",
            fontawesomeResizeFactor: 2.5,
            fontawesome: "fa fa-spinner fa-spin",
            fontawesomeColor: '#DDDDDD',
            fontawesomeOrder: 1,
            text: "Configuring your App",
            textResizeFactor: 0.17,
            textOrder: 2,
            textClass: "adjust-text",
            background: "rgba(240, 240, 255, 0.9)"
        });

        // Get the app instance from integration
        return this.getAppInstance()
            // Create OAuth client after role (required) and pass to server
            .then(() => this.addRole())

            // Create OAuth client after role (required) and pass to server
            .then((role) => this.addAuthClient(role))

            // Create or update a3s eb integrations
            .then((oauth) => this.addEbIntegration(product).then(() => oauth))

            // Add organization in User Templates configuration
            .then((oauth) => this.addOrganization(oauth, product))

            // When everything's finished, log a success message.
            .then(() => {
                this.logInfo('Installation Complete!');
                setTimeout(function () { $.LoadingOverlay("hide"); }, 1500);
            }).catch((err) => {
                this.logInfo('Error occured!');
                setTimeout(function () { $.LoadingOverlay("hide"); }, 1500);
                throw err;
            });
    }

    getAppInstance() {
        return this.getEntities(this.integrationsApi, 'getIntegrations')
            .then(entities => {
                console.log('Integrations: ' + JSON.stringify(entities, null, 3));
                console.log('Integrations: ' + JSON.stringify(this.integrationType, null, 3));

                return (entities.find(entity => entity.integrationType.id === this.integrationType));
            })
            .then(integration => {
                if (!(integration && integration.id)) {
                    throw new Error(`Could not find integration - "${this.appName}".`);
                }
                return integration;
            });
    }

    addEbIntegration(product) {
        this.logInfo('Adding eventbridge integration');
        return this.getEntities(this.integrationsApi, 'getIntegrations')
        .then((entities) => {
            const ebIntegrations = entities.filter((integration) => integration.integrationType.id === EbConstants.EbIntegrationId);
            const ebMainAccountSet = new Set(EbConstants.EbCreationAwsAccountId); 
            const ebAccountSetAlreadyExisting = new Set();
            console.log('EB Integrations: ' + JSON.stringify(ebIntegrations, null, 3));
            // Check existing a3s eb integration
            if (ebIntegrations.length > 0) {
                console.log("EB Available. Finding A3S EBs and Performing Updates If Necessary.");
                let passingIds = []; // This will have the id of a3s eventbridge integrations which will be updated
                let promises = [];
                let self = this;
                ebIntegrations.forEach(function(item) {
                    let promise = self.integrationsApi.getIntegrationConfigCurrent(item.id)
                    .then(function(response){
                        if(EbConstants.EbAwsAccountIds.includes(response.properties.awsAccountId)){
                            passingIds.push(item.id);
                            ebAccountSetAlreadyExisting.add(response.properties.awsAccountId);
                        }
                        if(ebMainAccountSet.has(response.properties.awsAccountId)){
                            ebMainAccountSet.delete(response.properties.awsAccountId);
                        }
                    })
                    .catch(function(err) {
                        console.error("Error getting integration config: " + item.id, err);
                    })
                    promises.push(promise);
                });
                Promise.all(promises).then(function(){
                    // Demo exist, dev also exist. Remove dev as demo is already a lower env
                    if(ebAccountSetAlreadyExisting.has(EbConstants.EBAwsDemoAccountId) && ebMainAccountSet.has(EbConstants.EBAwsDevAccountId)){
                        ebMainAccountSet.delete(EbConstants.EBAwsDevAccountId);
                    }
                    // Prod exist, comp also exist. Remove comp as prod is already a higher env
                    else if(ebAccountSetAlreadyExisting.has(EbConstants.EBAwsLegacyProdAccountId) && ebMainAccountSet.has(EbConstants.EBAwsComplianceAccountId)){
                        ebMainAccountSet.delete(EbConstants.EBAwsComplianceAccountId);
                    }
                    let promises = [];
                    if(passingIds.length > 0 || ebMainAccountSet.size > 0){
                        console.log("A3S EBs Found. Performing Updates.");
                        if(passingIds.length > 0) {
                            passingIds.forEach(function(item) {
                                let promise = self.integrationsApi.getIntegrationConfigCurrent(item)
                                .then(function(response){
                                    const integration = ebIntegrations.filter((int) => int.id === item)[0];
                                    const events = product.productId === EbConstants.A3SHistoricalProductId ? EbConstants.EbHistoricalEvents: EbConstants.EbDIEvents;
                                    const check1 = events.every(function(event) {
                                        return response.properties.eventFilter.includes(event);
                                    })
                                    const check2 = integration.reportedState.code !== "ACTIVE";
                                    // If an eb is present which passes all checks we use that
                                    if(check1 && !check2){
                                        self.logInfo("Eventbridge integration exists with required configurations: " + item);
                                    } 
                                    // We update an existing eb with additional info
                                    else if(!check1 || check2)
                                    {
                                        let newConfig = Object.assign({}, response);
                                        newConfig.properties.eventFilter = response.properties.eventFilter.concat(events.filter(ev => !response.properties.eventFilter.includes(ev)));
                                        let opts = { 
                                            "body": newConfig
                                        };
                                        self.integrationsApi.putIntegrationConfigCurrent(item, opts)
                                        .then(function(){
                                            if(check2){
                                                let opts = { 
                                                    "body": {"intendedState": "ENABLED"} 
                                                };
                                                self.integrationsApi.patchIntegration(item, opts)
                                                .then(function(data){
                                                    console.log(`patchIntegration success! data: ${JSON.stringify(data, null, 2)}`);
                                                })
                                                .catch(function(err) {
                                                    console.log("There was a failure calling patchIntegration");
                                                    console.error(err);
                                                });
                                            }
                                            else {
                                                self.logInfo("Eventbridge has been updated: " + item);
                                            }
                                        })
                                        .catch(function(err) {
                                            console.error("Failed to update config: " + item, err);
                                        })
                                    }                             
                                })
                                .catch(function(err) {
                                    console.error("Error getting integration config: " + item, err);
                                })
                                promises.push(promise);
                            })
                        } 
                        if(ebMainAccountSet.size > 0) {
                            // To make sure dev/prod exists for sure, if they are not present in existing integrations
                            ebMainAccountSet.forEach(function(item) {
                                try{
                                    for(let i = 0; i < EbConstants.EbCreationAwsAccountId.length; i++){
                                        if(item === EbConstants.EbCreationAwsAccountId[i]){
                                            let EbConf = {
                                                "name": EbConstants.EbCreationIntegrationName[i],
                                                "integrationType": {
                                                "id": EbConstants.EbIntegrationId
                                                },
                                                "intendedState": "ENABLED"
                                            }
                                            let opts = { 
                                                "body": EbConf
                                            };
                                            let promise = self.integrationsApi.postIntegrations(opts)
                                            .then(function(data) {
                                                console.log(`postIntegrations success! data: ${JSON.stringify(data, null, 2)}`);
                                                const events = product.productId === EbConstants.A3SHistoricalProductId ? EbConstants.EbHistoricalEvents : EbConstants.EbDIEvents;
                                                const integrationId = data.id;
                                                self.integrationsApi.getIntegrationConfigCurrent(integrationId)
                                                .then(function(response) {
                                                    let newConfig = Object.assign({}, response);
                                                    let pcEnv = sessionStorage.getItem('purecloud-csp-env');
                                                    newConfig.properties.eventFilter = events;
                                                    newConfig.properties.awsAccountRegion = getRegionalConfiguration(pcEnv).aws;
                                                    newConfig.properties.eventSourceSuffix = EbConstants.EbCreationEventSourceSuffix[i];
                                                    newConfig.properties.awsAccountId = EbConstants.EbCreationAwsAccountId[i];
                                                    let opts = { 
                                                        "body": newConfig 
                                                    };
                                                    self.integrationsApi.putIntegrationConfigCurrent(integrationId, opts)
                                                    .then(function(data) {
                                                        console.log(`putIntegration success! data: ${JSON.stringify(data, null, 2)}`);
                                                        let opts = { 
                                                            "body": {"intendedState": "ENABLED"} 
                                                        };
                                                        self.integrationsApi.patchIntegration(integrationId, opts)
                                                        .then(function(data) {
                                                            console.log(`patchIntegration success! data: ${JSON.stringify(data, null, 2)}`);
                                                        })
                                                        .catch(function(err) {
                                                            console.log("There was a failure calling patchIntegration");
                                                            console.error(err);
                                                        });
                                                    })
                                                    .catch(function(err) {
                                                        console.error("Failed to update config: " + data.id, err);
                                                    })
                                                })
                                                .catch(function(err) {
                                                    console.error("Error getting config: " + data.id, err);
                                                })
                                            })
                                            .catch(function(err) {
                                                console.log("There was a failure calling postIntegrations");
                                                console.error(err);
                                            });  
                                            promises.push(promise);
                                        }              
                                    }
                                } catch(error) {
                                    console.log("There was a failure in creating EB integration");
                                    console.error(err);
                                }
                            })
                        }
                        Promise.all(promises).then(function(){
                            self.logInfo("A3S EB has been created/updated.")
                        })
                    } else { 
                        console.log("No A3S EBs Found. Creating A New One.");
                        self.createA3sEbIntegration(product)
                        .then(function() {
                            self.logInfo(`EB integration has been created for A3S`);
                        })
                        .catch(function(err) {
                            console.log("There was a failure creating EB integration for A3S");
                            console.error(err);
                        });
                    }
                })
            } 
            // create new integration
            else {
                let self = this;
                console.log("A3S EB Not Available. Creating A New One.");
                this.createA3sEbIntegration(product)
                .then(function() {
                    self.logInfo(`EB integration has been created for A3S`);
                })
                .catch(function(err) {
                    console.log("There was a failure creating EB integration for A3S");
                    console.error(err);
                });
            }
        });
    }

    /**
     * Create a new A3S EB Integration
     * @returns {Promise}
     */
    createA3sEbIntegration(product){
        let self = this;
        return new Promise((resolve, reject) => {
            try{
                for(let i = 0; i < EbConstants.EbCreationAwsAccountId.length; i++){
                    let EbConf = {
                        "name": EbConstants.EbCreationIntegrationName[i],
                        "integrationType": {
                        "id": EbConstants.EbIntegrationId
                        },
                        "intendedState": "ENABLED"
                    }
                    let opts = { 
                        "body": EbConf
                    };
                    self.integrationsApi.postIntegrations(opts)
                    .then(function(data) {
                        console.log(`postIntegrations success! data: ${JSON.stringify(data, null, 2)}`);
                        const events = product.productId === EbConstants.A3SHistoricalProductId ? EbConstants.EbHistoricalEvents : EbConstants.EbDIEvents;
                        const integrationId = data.id;
                        self.integrationsApi.getIntegrationConfigCurrent(integrationId)
                        .then(function(response) {
                            let newConfig = Object.assign({}, response);
                            let pcEnv = sessionStorage.getItem('purecloud-csp-env');
                            newConfig.properties.eventFilter = events;
                            newConfig.properties.awsAccountRegion = getRegionalConfiguration(pcEnv).aws;
                            newConfig.properties.eventSourceSuffix = EbConstants.EbCreationEventSourceSuffix[i];
                            newConfig.properties.awsAccountId = EbConstants.EbCreationAwsAccountId[i];
                            let opts = { 
                                "body": newConfig 
                            };
                            self.integrationsApi.putIntegrationConfigCurrent(integrationId, opts)
                            .then(function(data) {
                                console.log(`putIntegration success! data: ${JSON.stringify(data, null, 2)}`);
                                let opts = { 
                                    "body": {"intendedState": "ENABLED"} 
                                };
                                self.integrationsApi.patchIntegration(integrationId, opts)
                                .then(function(data) {
                                    console.log(`patchIntegration success! data: ${JSON.stringify(data, null, 2)}`);
                                })
                                .catch(function(err) {
                                    console.log("There was a failure calling patchIntegration");
                                    console.error(err);
                                });
                            })
                            .catch(function(err) {
                                console.error("Failed to update config: " + data.id, err);
                            })
                        })
                        .catch(function(err) {
                            console.error("Error getting config: " + data.id, err);
                        })
                    })
                    .catch(function(err) {
                        console.log("There was a failure calling postIntegrations");
                        console.error(err);
                    });                
                }
                resolve();    
            } catch(error) {
                reject(error);
            }
        })
    }

    /**
     * Add PureCLoud role based on installation data
     * @returns {Promise}
     */
    addRole() {
        console.log('Adding role');
        this.logInfo('Creating role ' + appConfig.appName);
        console.log(`Role Name as per Config is ${this.installationData.roles[0].name}`);
        let roleName = this.installationData.roles[0].name;

        const roleBody = {
            name: roleName,
            description: this.installationData.roles[0].description,
            permissionPolicies: this.installationData.roles[0].permissionPolicies
        };

        let role;

        // Create the role
        return this.authApi.postAuthorizationRoles(roleBody)
            .then((data) => {
                this.logInfo('Created role ' + appConfig.appName);
                role = data;
                return this.getUserDetails();
            })
            .then((user) => {
                // Assign the role to the user
                // Required before you can assign the role to an Auth Client.
                console.log(` ORG Data is ${JSON.stringify(this.org)}`);
                let body = {
                    "subjectIds": [
                      user.id
                    ],
                    "divisionIds": [
                      "*"
                    ]
                  }; // Object | Subjects and Divisions
                let opts = { 
                "subjectType": "PC_USER" // String | what the type of the subjects are (PC_GROUP, PC_USER or PC_OAUTH_CLIENT)
                };

                // Bulk-grant subjects and divisions with an organization role.
                this.authApi.postAuthorizationRole(role.id, body, opts)
                .then(() => {
                    console.log("postAuthorizationRole returned successfully.");
                })
                .catch((err) => {
                    console.log("There was a failure calling postAuthorizationRole");
                    console.error(err);
                });


                return this.authApi.putAuthorizationRoleUsersAdd(role.id, [user.id]);
            })
            .then(() => {
                
                    this.logInfo('Assigned role ' + appConfig.appName + ' to user');
                    return role;
                
                
            })
            .catch((err) => {
                console.log('Role creation error:' + JSON.stringify(err, null, 3));
                throw err;
            });
    }


    getDivisions() {
        let divisionOpts = {
            'pageSize': 100, 'pageNumber': 1
            } ;
        return this.objectsApi.getAuthorizationDivisions(divisionOpts)
        .then((data) => {
            this.logInfo(`divisionsResponse is "${JSON.stringify(data)}"`);
            return data;
        })
        .catch((err) => {
            console.log('Oauth creation error:' + JSON.stringify(err, null, 3));
            throw err;
        })
    }


    /**
     * Add PureCLoud instance based on installation data
     * @returns {Promise.<Array>} PureCloud OAuth objects
     */
    addAuthClient(role) {
        console.log('Adding oauth client');
        this.logInfo('Creating oauth client');
        let  OAuthname = this.installationData.oauth.name;
           
        let roleDivisionOpts=  [{
            "roleId": role.id,
            "divisionId": "*"
         }];
        

        const oauthClient = {
            name: OAuthname,
            description: this.installationData.oauth.description,
            roleDivisions: roleDivisionOpts,
            authorizedGrantType: "CLIENT_CREDENTIALS"
        };

        return this.oAuthApi.postOauthClients(oauthClient)
            .then((data) => {
                this.logInfo(`Created OAuth client "${this.installationData.oauth.name}"`);
                return data;
            })
            .catch((err) => {
                console.log('Oauth creation error:' + JSON.stringify(err, null, 3));
                throw err;
            })
    }

    //// =======================================================
    ////      ORGANIZATION
    //// =======================================================

    addOrganization(oauth, product) {
        console.log('Adding organization');
        this.logInfo('Adding org');

        console.log(appConfig.endpoints.backend + '/addOrg/' + this.org.id)

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                headers: {
                    'token': sessionStorage.getItem('purecloud-csp-token'),
                    'env': this.pcEnvironment,
                    'tokensource': 'purecloud'
                },
                url: appConfig.endpoints.backend + '/addOrg/' + this.org.id,
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ clientId: oauth.id, clientSecret: oauth.secret, orgName: this.org.thirdPartyOrgName, product: product }),
                success: function (result) {
                    console.log('Added org');
                    resolve()
                },
                error: function (xhr, status, error) {
                    console.log('addOrganization, xhr = ' + JSON.stringify(xhr, null, 3));
                    console.log('addOrganization, status = ' + JSON.stringify(status, null, 3));
                    console.log('addOrganization, error = ' + JSON.stringify(error, null, 3));

                    reject("Error in adding organisation.");
                }
            });
        });
    }


    //// =======================================================
    ////      DISPLAY/UTILITY FUNCTIONS
    //// =======================================================

    /**
     * Shows an overlay with the specified data string
     * @param {string} data 
     */
    logInfo(data) {
        if (!data || (typeof (data) !== 'string')) data = "";

        $.LoadingOverlay("text", data);
    }


    //// =======================================================
    ////      UTILITIES
    //// =======================================================

    getEntities(api, func, options) {
        const entities = [];
        let pageNumber = 1;

        const getEntitiesWorker = () => {
            return api[func]({ ...options, pageSize, pageNumber })
                .then((data) => {
                    console.log(`${func}, pageSize = ${pageSize}, pageNumber = ${pageNumber}, entities = ${data.entities.length}`);
                    entities.push(...data.entities);
                    return (pageNumber++ < data.pageCount) ? getEntitiesWorker() : entities;
                });
        }
        return getEntitiesWorker();
    }

}


export default WizardApp;